<template>
  <div class="assess-dialog">
    <el-dialog title="填写详情" @open="dialogOpen" :visible.sync="assessDialogShow" :before-close="dialogClose"
      width="850px">
      <div class="table" v-if="assessData && teacherProblemList">
        <el-form>
          <el-form-item v-for="(item, index) in teacherProblemList" :key="index"
            :label="index + 1 + '.' + item.questionDesc" :label-position="labelPosition" style="text-align: left">
            <el-radio-group v-model="item.val" :disabled="disabled">
              <el-radio v-for="(rItem, rIndex) in item.teacherEvaluationOptions" :key="rIndex" :label="rItem.optionDesc"
                class="radio-item" @change="optionChange(index, rItem.id, $event)"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["assessDialogShow", "assessData", "teacherProblemList", "schoolInfo", "studentForm", "submitDataChild"],
  data() {
    return {
      disabled: false,
      labelPosition: "top",
      submitData: []
    };
  },
  methods: {
    dialogOpen() {
      this.$nextTick(() => {
        const tableEl = this.$el.querySelector('.table');
        if (tableEl) {
          tableEl.scrollTop = 0;
        }
      });
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:assessDialogShow", false);
    },
    confirm() {
      // console.log(this.submitDataChild);
      if (this.submitDataChild.length !== this.teacherProblemList.length || this.submitDataChild.some(item => !item.optionId)) {
        this.$message({
          message: "请完成所有问题",
          type: "warning"
        });
        return;
      };
      this.$emit("update:assessDialogShow", false);
      this.$emit("submitData", this.submitDataChild);
    },
    optionChange(index, optionId) {
      // console.log("this.submitData:", this.submitDataChild, index, optionId);
      this.submitDataChild[index].optionId = optionId;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./assessDialog.scss";
</style>